module.exports = __webpack_public_path__ + "static/media/Fear.6c54a922.png";